import React from 'react';
import PropTypes from 'prop-types';

import { strings, getCurrentLocale } from './../../../localization';
import globals from './../../../components/common/globals';
import Switch from './../../../components/common/Switch';
import ProgressOverlay from './../../../components/common/ProgressOverlay';
import { ModalContainer } from './../../../components/common/Modal2';

import { UPDATE_SETTINGS_TIMEOUT } from './GlobalSettings';

export default class Audio extends React.PureComponent {

    static propTypes = {
        audioAvailabilityPending: PropTypes.bool.isRequired,
        audioAvailabilityEnabled: PropTypes.bool,
        audioAvailabilitySettingLocked: PropTypes.bool,
        audioAvailabilitySettingLockedElement: PropTypes.element,
        audioAvailabilityErrorMessage: PropTypes.string,
        applyAudioAvailability: PropTypes.func.isRequired,
        timeoutAudioAvailability: PropTypes.func.isRequired,

        streamingVideoAudioAvailabilityPending: PropTypes.bool.isRequired,
        streamingVideoAudioAvailabilityEnabled: PropTypes.bool,
        streamingVideoAudioAvailabilitySettingLocked: PropTypes.bool,
        streamingVideoAudioAvailabilitySettingElement: PropTypes.element,
        streamingVideoAudioAvailabilityErrorMessage: PropTypes.string,
        applyStreamingVideoAudioAvailability: PropTypes.func.isRequired,
        timeoutStreamingVideoAudioAvailability: PropTypes.func.isRequired,

        showConfirmationDialog: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        audioExpandReference: PropTypes.string.isRequired,
        audioExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        streamingVideoAudioExpandReference: PropTypes.string.isRequired,
        streamingVideoAudioExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.applyAudioAvailabilityTimeoutId = undefined;
        this.applyStreamingVideoAudioAvailabilityTimeoutId = undefined;
    }

    componentWillUnmount() {
        clearTimeout(this.applyAudioAvailabilityTimeoutId);
        clearTimeout(this.applyStreamingVideoAudioAvailabilityTimeoutId);
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.audioExpandReference,
            this.props.streamingVideoAudioExpandReference
        ]);
    }

    render() {

        return (
            <div id="component_document_id_audio">
                <h3>
                    <button
                        className={this.props.streamingVideoAudioExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.audioExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_audio_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div>{strings.settings_global_audio_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group switch-group'>
                        <div>

                            <Switch
                                onChange={() => {
                                    clearTimeout(this.applyAudioAvailabilityTimeoutId);
                                    const audioAvailabilityEnabled = this.props.audioAvailabilityEnabled;
                                    if (!this.props.audioAvailabilityEnabled) {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.audio_recording_enabled_warning_eula_title} smallDialogMode={true} onClickClose={this.props.dismissConfirmationDialog}>
                                                <div className="message">
                                                    <p>{strings.audio_recording_enabled_warning_eula_intro} <a href={globals.eulaUrl + '#' + getCurrentLocale()} target="_blank" rel="noopener noreferrer">{strings.raven_eula_lable}</a>.</p>
                                                    <p>{strings.audio_recording_please_ensure_you_are_in_compliance_with_local_laws_warning}</p>
                                                </div>
                                                <div className="actions">
                                                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                                                    <button onClick={() => {
                                                        this.applyAudioAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutAudioAvailability(audioAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);

                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyAudioAvailability(!this.props.audioAvailabilityEnabled)
                                                        .then(
                                                            () => {clearTimeout(this.applyAudioAvailabilityTimeoutId)},
                                                            () => {clearTimeout(this.applyAudioAvailabilityTimeoutId)}
                                                        )
                                                    }} >{strings.action_enable}</button>
                                                </div>
                                            </ModalContainer>
                                        );
                                    } else {
                                        this.applyAudioAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutAudioAvailability(audioAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);
                                        this.props.applyAudioAvailability(!this.props.audioAvailabilityEnabled)
                                        .then(
                                            () => {clearTimeout(this.applyAudioAvailabilityTimeoutId)},
                                            () => {clearTimeout(this.applyAudioAvailabilityTimeoutId)}
                                        )
                                    }
                                }}
                                checked={this.props.audioAvailabilityEnabled || false}
                                disabled={this.props.audioAvailabilityPending || this.props.audioAvailabilitySettingLocked}
                                smallFormat={true}
                            />

                            <label disabled={this.props.audioAvailabilityPending}>{this.props.audioAvailabilityEnabled?
                                strings.settings_feature_enabled
                            :
                                strings.settings_feature_disabled
                            }</label>
                            {this.props.audioAvailabilityPending ? <ProgressOverlay /> : null }
                            {this.props.audioAvailabilitySettingLocked ? <div className='disabled-overlay'></div> : null }
                        </div>
                        <div className="error-message">
                            {this.props.audioAvailabilityErrorMessage}
                        </div>
                        {this.props.audioAvailabilitySettingLockedElement}
                    </div>
                    <div className={this.props.streamingVideoAudioExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.streamingVideoAudioExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.streamingVideoAudioExpandReferenceIsExpanded,
                                        [this.props.streamingVideoAudioExpandReference])
                                }}>
                                {strings.settings_global_streaming_audio_header}
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                        <div className="description">
                            {strings.settings_global_streaming_audio_description}
                        </div>
                        <div className='setting-group switch-group'>
                            <div>
                                <Switch
                                    onChange={() => {

                                        clearTimeout(this.applyStreamingVideoAudioAvailabilityTimeoutId);
                                        const streamingVideoAudioAvailabilityEnabled = this.props.streamingVideoAudioAvailabilityEnabled;
                                        this.applyStreamingVideoAudioAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutStreamingVideoAudioAvailability(streamingVideoAudioAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);
                                        this.props.dismissConfirmationDialog();
                                        this.props.applyStreamingVideoAudioAvailability(!this.props.streamingVideoAudioAvailabilityEnabled)
                                        .then(
                                            () => {clearTimeout(this.applyStreamingVideoAudioAvailabilityTimeoutId)},
                                            () => {clearTimeout(this.applyStreamingVideoAudioAvailabilityTimeoutId)}
                                        )
                                    }}
                                    checked={this.props.streamingVideoAudioAvailabilityEnabled || false}
                                    disabled={this.props.streamingVideoAudioAvailabilityPending || this.props.streamingVideoAudioAvailabilitySettingLocked}
                                    smallFormat={true}
                                />
                                <label disabled={this.props.streamingVideoAudioAvailabilityPending}>{this.props.streamingVideoAudioAvailabilityEnabled?
                                    strings.settings_feature_enabled
                                :
                                    strings.settings_feature_disabled
                                }</label>
                                {this.props.streamingVideoAudioAvailabilityPending ? <ProgressOverlay /> : null }
                                {this.props.streamingVideoAudioAvailabilitySettingLocked ? <div className='disabled-overlay'></div> : null }
                            </div>
                        </div>
                        <div className="error-message">
                            {this.props.streamingVideoAudioAvailabilityErrorMessage}
                        </div>
                        {this.props.streamingVideoAudioAvailabilitySettingElement}
                    </div>
                </div>

            </div>
        );
    }
}
